import type { ShopCollectionProduct } from './bootstrap'

// The featured collections' rendering order (GLOSSARY.md "Shop product
// collection"): display_order ascending, equal values broken by
// collection-entry id ascending — never response order. A missing
// display_order sorts last.
export function compareByDisplayOrder(
  left: ShopCollectionProduct,
  right: ShopCollectionProduct,
): number {
  const leftOrder =
    typeof left.display_order === 'number'
      ? left.display_order
      : Number.POSITIVE_INFINITY
  const rightOrder =
    typeof right.display_order === 'number'
      ? right.display_order
      : Number.POSITIVE_INFINITY
  return leftOrder - rightOrder || left.id - right.id
}
